import { API } from "./api";

export const getAllScreens = (params = {}) => {
  return API.get(`/screens`, { params });
};
export const getScreenById = (screenId) => API.get(`screens/${screenId}`);
export const getMonthlyScreenCount = (screenId) =>
  API.get(`screens/calculateMonthlyScreenCount/${screenId}`);
export const getPositionLogs = (id) => API.get(`/screens/${id}/position-logs`);
export const addScreen = (screen) => API.post(`/screens`, screen);
export const deleteScreen = (screenId) => API.delete(`/screens/${screenId}`);
export const updateScreen = (screenId, screen) =>
  API.put(`/screens/${screenId}`, screen);

export const screensAvailable = (availableScreen) =>
  API.post(`/campaigns/screens-available`, availableScreen);

export const Enhanced = (screenId) => API.get(`/screens/enhanced/${screenId}`);
